import { render, staticRenderFns } from "./ModifyDosage.vue?vue&type=template&id=105d97a4"
import script from "./ModifyDosage.vue?vue&type=script&lang=js"
export * from "./ModifyDosage.vue?vue&type=script&lang=js"
import style0 from "./ModifyDosage.vue?vue&type=style&index=0&id=105d97a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports